import Typography from "@material-ui/core/Typography";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import React from "react";
import {
  IQuestionRequest,
  ISanitizedSurveyQuestion,
  TemplateQuestionType,
} from "src/services";
import Component from "../../../components/Component";
import RadioScale from "../../../components/RadioScale";

const styles = (theme: Theme): Record<string, CSSProperties> => ({
  question: {
    fontSize: 19,
    fontWeight: 600,
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
  questionNumber: {
    paddingRight: "7px",
  },
  questionTextDiv: {
    display: "flex",
  },
  textArea: {
    border: "1px solid darkgrey",
    fontSize: "16px",
    padding: "0.5em",
    resize: "vertical",
    width: "98%",
  },
});

interface IQuestionProps {
  question: ISanitizedSurveyQuestion;
  categoryIndex: number;
  index: number;
  // TODO: You’re building a new handler every render. That is wrong.
  handleResponseChange: (
    i: number
  ) => (e: React.ChangeEvent<HTMLElement | { value: string }>) => void;
  // surveyRequest: ISurveyRespondentRequest;
  questionResponse: IQuestionRequest;
}

type IProps = IQuestionProps & WithStyles<keyof ReturnType<typeof styles>>;

export default withStyles(styles)(
  class Question extends Component<IProps, {}> {
    public render() {
      const {
        // surveyRequest,
        question,
        index,
        questionResponse,
        classes,
      } = this.props;
      // const questionResponse = surveyRequest.questionResponses[index];
      if (questionResponse === undefined) {
        return <div>Something is wrong</div>;
      }
      switch (question.type) {
        case TemplateQuestionType.scale:
          return (
            <div>
              <this.question>{question.text}</this.question>
              <RadioScale
                scale={question.scaleScale}
                onChange={this.props.handleResponseChange(index)}
                reversed={question.scaleReversed}
                value={questionResponse.response}
                positiveText={question.scalePositiveText}
                negativeText={question.scaleNegativeText}
              />
            </div>
          );
        case TemplateQuestionType.written:
          return (
            <div>
              <this.question>{question.text}</this.question>
              <div>
                <textarea
                  className={classes.textArea}
                  rows={4}
                  value={questionResponse.response}
                  onChange={this.props.handleResponseChange(index)}
                />
              </div>
            </div>
          );
        default:
          return <span>error. this should not happen</span>;
      }
    }

    private question = (props: { children: any }) => {
      const { categoryIndex, classes } = this.props;
      return (
        <div className={classes.questionTextDiv}>
          <div className={`${classes.questionNumber} ${classes.question}`}>
            {categoryIndex === -1 ? null : categoryIndex + 1 + ". "}
          </div>
          <Typography variant="body1" className={classes.question}>
            {props.children}
          </Typography>
        </div>
      );
    };
  }
);



// WEBPACK FOOTER //
// ./src/pages/respondent/surveyRespondPage/Question.tsx